import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import ot from "./styles/index.cssr.js";
import me from "../../../_mixins/use-theme.js";
import nt from "../../../_mixins/use-config.js";
import { useRtl as rt } from "../../../_mixins/use-rtl.js";
import it from "../../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-is-ios.js";
import at from "../styles/light.js";
import { depx as ue, getMargin as D } from "../../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import { useReactivated as st } from "../../../_utils/composable/use-reactivated.js";
import { off as C, on as I } from "../../../../../../../evtd@0.2.4/node_modules/evtd/es/delegate.js";
import { rtlInset as fe } from "../../../_utils/css/rtl-inset.js";
import { useThemeClass as ct } from "../../../_mixins/use-css-vars-class.js";
import de from "../../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/resize-observer/src/VResizeObserver.js";
import { Wrapper as he } from "../../../_utils/vue/wrapper.js";
import { getPreciseEventTarget as ut } from "../../../../../../../seemly@0.3.10/node_modules/seemly/es/dom/get-precise-event-target.js";
import { defineComponent as ft, computed as c, watchEffect as dt, onMounted as ht, onBeforeUnmount as vt, h as v, Fragment as mt, mergeProps as bt } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as u } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { Transition as ve } from "../../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
const gt = Object.assign(Object.assign({}, me.props), {
  duration: {
    type: Number,
    default: 0
  },
  scrollable: {
    type: Boolean,
    default: !0
  },
  xScrollable: Boolean,
  trigger: {
    type: String,
    default: "hover"
  },
  useUnifiedContainer: Boolean,
  triggerDisplayManually: Boolean,
  // If container is set, resize observer won't not attached
  container: Function,
  content: Function,
  containerClass: String,
  containerStyle: [String, Object],
  contentClass: [String, Array],
  contentStyle: [String, Object],
  horizontalRailStyle: [String, Object],
  verticalRailStyle: [String, Object],
  onScroll: Function,
  onWheel: Function,
  onResize: Function,
  internalOnUpdateScrollLeft: Function,
  internalHoistYRail: Boolean,
  yPlacement: {
    type: String,
    default: "right"
  },
  xPlacement: {
    type: String,
    default: "bottom"
  }
}), be = ft({
  name: "Scrollbar",
  props: gt,
  inheritAttrs: !1,
  setup(i) {
    const {
      mergedClsPrefixRef: R,
      inlineThemeDisabled: s,
      mergedRtlRef: $
    } = nt(i), o = rt("Scrollbar", $, R), W = u(null), Y = u(null), E = u(null), M = u(null), S = u(null), w = u(null), B = u(null), y = u(null), d = u(null), p = u(null), V = u(null), H = u(0), X = u(0), O = u(!1), U = u(!1);
    let _ = !1, j = !1, m, b, K = 0, Q = 0, F = 0, Z = 0;
    const ge = it(), N = me("Scrollbar", "-scrollbar", ot, at, i, R), A = c(() => {
      const {
        value: e
      } = y, {
        value: t
      } = w, {
        value: l
      } = p;
      return e === null || t === null || l === null ? 0 : Math.min(e, l * e / t + ue(N.value.self.width) * 1.5);
    }), Re = c(() => `${A.value}px`), G = c(() => {
      const {
        value: e
      } = d, {
        value: t
      } = B, {
        value: l
      } = V;
      return e === null || t === null || l === null ? 0 : l * e / t + ue(N.value.self.height) * 1.5;
    }), pe = c(() => `${G.value}px`), Se = c(() => {
      const {
        value: e
      } = y, {
        value: t
      } = H, {
        value: l
      } = w, {
        value: n
      } = p;
      if (e === null || l === null || n === null)
        return 0;
      {
        const a = l - e;
        return a ? t / a * (n - A.value) : 0;
      }
    }), we = c(() => `${Se.value}px`), Be = c(() => {
      const {
        value: e
      } = d, {
        value: t
      } = X, {
        value: l
      } = B, {
        value: n
      } = V;
      if (e === null || l === null || n === null)
        return 0;
      {
        const a = l - e;
        return a ? t / a * (n - G.value) : 0;
      }
    }), ye = c(() => `${Be.value}px`), ee = c(() => {
      const {
        value: e
      } = y, {
        value: t
      } = w;
      return e !== null && t !== null && t > e;
    }), te = c(() => {
      const {
        value: e
      } = d, {
        value: t
      } = B;
      return e !== null && t !== null && t > e;
    }), xe = c(() => {
      const {
        trigger: e
      } = i;
      return e === "none" || O.value;
    }), ze = c(() => {
      const {
        trigger: e
      } = i;
      return e === "none" || U.value;
    }), z = c(() => {
      const {
        container: e
      } = i;
      return e ? e() : Y.value;
    }), Te = c(() => {
      const {
        content: e
      } = i;
      return e ? e() : E.value;
    }), le = (e, t) => {
      if (!i.scrollable)
        return;
      if (typeof e == "number") {
        L(e, t != null ? t : 0, 0, !1, "auto");
        return;
      }
      const {
        left: l,
        top: n,
        index: a,
        elSize: f,
        position: g,
        behavior: r,
        el: h,
        debounce: x = !0
      } = e;
      (l !== void 0 || n !== void 0) && L(l != null ? l : 0, n != null ? n : 0, 0, !1, r), h !== void 0 ? L(0, h.offsetTop, h.offsetHeight, x, r) : a !== void 0 && f !== void 0 ? L(0, a * f, f, x, r) : g === "bottom" ? L(0, Number.MAX_SAFE_INTEGER, 0, !1, r) : g === "top" && L(0, 0, 0, !1, r);
    }, oe = st(() => {
      i.container || le({
        top: H.value,
        left: X.value
      });
    }), Me = () => {
      oe.isDeactivated || T();
    }, He = (e) => {
      if (oe.isDeactivated)
        return;
      const {
        onResize: t
      } = i;
      t && t(e), T();
    }, Le = (e, t) => {
      if (!i.scrollable)
        return;
      const {
        value: l
      } = z;
      l && (typeof e == "object" ? l.scrollBy(e) : l.scrollBy(e, t || 0));
    };
    function L(e, t, l, n, a) {
      const {
        value: f
      } = z;
      if (f) {
        if (n) {
          const {
            scrollTop: g,
            offsetHeight: r
          } = f;
          if (t > g) {
            t + l <= g + r || f.scrollTo({
              left: e,
              top: t + l - r,
              behavior: a
            });
            return;
          }
        }
        f.scrollTo({
          left: e,
          top: t,
          behavior: a
        });
      }
    }
    function Pe() {
      $e(), Ye(), T();
    }
    function Ce() {
      k();
    }
    function k() {
      We(), Xe();
    }
    function We() {
      b !== void 0 && window.clearTimeout(b), b = window.setTimeout(() => {
        U.value = !1;
      }, i.duration);
    }
    function Xe() {
      m !== void 0 && window.clearTimeout(m), m = window.setTimeout(() => {
        O.value = !1;
      }, i.duration);
    }
    function $e() {
      m !== void 0 && window.clearTimeout(m), O.value = !0;
    }
    function Ye() {
      b !== void 0 && window.clearTimeout(b), U.value = !0;
    }
    function Ee(e) {
      const {
        onScroll: t
      } = i;
      t && t(e), ne();
    }
    function ne() {
      const {
        value: e
      } = z;
      e && (H.value = e.scrollTop, X.value = e.scrollLeft * (o != null && o.value ? -1 : 1));
    }
    function Ve() {
      const {
        value: e
      } = Te;
      e && (w.value = e.offsetHeight, B.value = e.offsetWidth);
      const {
        value: t
      } = z;
      t && (y.value = t.offsetHeight, d.value = t.offsetWidth);
      const {
        value: l
      } = S, {
        value: n
      } = M;
      l && (V.value = l.offsetWidth), n && (p.value = n.offsetHeight);
    }
    function re() {
      const {
        value: e
      } = z;
      e && (H.value = e.scrollTop, X.value = e.scrollLeft * (o != null && o.value ? -1 : 1), y.value = e.offsetHeight, d.value = e.offsetWidth, w.value = e.scrollHeight, B.value = e.scrollWidth);
      const {
        value: t
      } = S, {
        value: l
      } = M;
      t && (V.value = t.offsetWidth), l && (p.value = l.offsetHeight);
    }
    function T() {
      i.scrollable && (i.useUnifiedContainer ? re() : (Ve(), ne()));
    }
    function ie(e) {
      var t;
      return !(!((t = W.value) === null || t === void 0) && t.contains(ut(e)));
    }
    function De(e) {
      e.preventDefault(), e.stopPropagation(), j = !0, I("mousemove", window, ae, !0), I("mouseup", window, se, !0), Q = X.value, F = o != null && o.value ? window.innerWidth - e.clientX : e.clientX;
    }
    function ae(e) {
      if (!j)
        return;
      m !== void 0 && window.clearTimeout(m), b !== void 0 && window.clearTimeout(b);
      const {
        value: t
      } = d, {
        value: l
      } = B, {
        value: n
      } = G;
      if (t === null || l === null)
        return;
      const f = (o != null && o.value ? window.innerWidth - e.clientX - F : e.clientX - F) * (l - t) / (t - n), g = l - t;
      let r = Q + f;
      r = Math.min(g, r), r = Math.max(r, 0);
      const {
        value: h
      } = z;
      if (h) {
        h.scrollLeft = r * (o != null && o.value ? -1 : 1);
        const {
          internalOnUpdateScrollLeft: x
        } = i;
        x && x(r);
      }
    }
    function se(e) {
      e.preventDefault(), e.stopPropagation(), C("mousemove", window, ae, !0), C("mouseup", window, se, !0), j = !1, T(), ie(e) && k();
    }
    function Ie(e) {
      e.preventDefault(), e.stopPropagation(), _ = !0, I("mousemove", window, q, !0), I("mouseup", window, J, !0), K = H.value, Z = e.clientY;
    }
    function q(e) {
      if (!_)
        return;
      m !== void 0 && window.clearTimeout(m), b !== void 0 && window.clearTimeout(b);
      const {
        value: t
      } = y, {
        value: l
      } = w, {
        value: n
      } = A;
      if (t === null || l === null)
        return;
      const f = (e.clientY - Z) * (l - t) / (t - n), g = l - t;
      let r = K + f;
      r = Math.min(g, r), r = Math.max(r, 0);
      const {
        value: h
      } = z;
      h && (h.scrollTop = r);
    }
    function J(e) {
      e.preventDefault(), e.stopPropagation(), C("mousemove", window, q, !0), C("mouseup", window, J, !0), _ = !1, T(), ie(e) && k();
    }
    dt(() => {
      const {
        value: e
      } = te, {
        value: t
      } = ee, {
        value: l
      } = R, {
        value: n
      } = S, {
        value: a
      } = M;
      n && (e ? n.classList.remove(`${l}-scrollbar-rail--disabled`) : n.classList.add(`${l}-scrollbar-rail--disabled`)), a && (t ? a.classList.remove(`${l}-scrollbar-rail--disabled`) : a.classList.add(`${l}-scrollbar-rail--disabled`));
    }), ht(() => {
      i.container || T();
    }), vt(() => {
      m !== void 0 && window.clearTimeout(m), b !== void 0 && window.clearTimeout(b), C("mousemove", window, q, !0), C("mouseup", window, J, !0);
    });
    const ce = c(() => {
      const {
        common: {
          cubicBezierEaseInOut: e
        },
        self: {
          color: t,
          colorHover: l,
          height: n,
          width: a,
          borderRadius: f,
          railInsetHorizontalTop: g,
          railInsetHorizontalBottom: r,
          railInsetVerticalRight: h,
          railInsetVerticalLeft: x,
          railColor: Oe
        }
      } = N.value, {
        top: Ue,
        right: _e,
        bottom: je,
        left: Fe
      } = D(g), {
        top: Ne,
        right: Ae,
        bottom: Ge,
        left: ke
      } = D(r), {
        top: qe,
        right: Je,
        bottom: Ke,
        left: Qe
      } = D(o != null && o.value ? fe(h) : h), {
        top: Ze,
        right: et,
        bottom: tt,
        left: lt
      } = D(o != null && o.value ? fe(x) : x);
      return {
        "--n-scrollbar-bezier": e,
        "--n-scrollbar-color": t,
        "--n-scrollbar-color-hover": l,
        "--n-scrollbar-border-radius": f,
        "--n-scrollbar-width": a,
        "--n-scrollbar-height": n,
        "--n-scrollbar-rail-top-horizontal-top": Ue,
        "--n-scrollbar-rail-right-horizontal-top": _e,
        "--n-scrollbar-rail-bottom-horizontal-top": je,
        "--n-scrollbar-rail-left-horizontal-top": Fe,
        "--n-scrollbar-rail-top-horizontal-bottom": Ne,
        "--n-scrollbar-rail-right-horizontal-bottom": Ae,
        "--n-scrollbar-rail-bottom-horizontal-bottom": Ge,
        "--n-scrollbar-rail-left-horizontal-bottom": ke,
        "--n-scrollbar-rail-top-vertical-right": qe,
        "--n-scrollbar-rail-right-vertical-right": Je,
        "--n-scrollbar-rail-bottom-vertical-right": Ke,
        "--n-scrollbar-rail-left-vertical-right": Qe,
        "--n-scrollbar-rail-top-vertical-left": Ze,
        "--n-scrollbar-rail-right-vertical-left": et,
        "--n-scrollbar-rail-bottom-vertical-left": tt,
        "--n-scrollbar-rail-left-vertical-left": lt,
        "--n-scrollbar-rail-color": Oe
      };
    }), P = s ? ct("scrollbar", void 0, ce, i) : void 0;
    return Object.assign(Object.assign({}, {
      scrollTo: le,
      scrollBy: Le,
      sync: T,
      syncUnifiedContainer: re,
      handleMouseEnterWrapper: Pe,
      handleMouseLeaveWrapper: Ce
    }), {
      mergedClsPrefix: R,
      rtlEnabled: o,
      containerScrollTop: H,
      wrapperRef: W,
      containerRef: Y,
      contentRef: E,
      yRailRef: M,
      xRailRef: S,
      needYBar: ee,
      needXBar: te,
      yBarSizePx: Re,
      xBarSizePx: pe,
      yBarTopPx: we,
      xBarLeftPx: ye,
      isShowXBar: xe,
      isShowYBar: ze,
      isIos: ge,
      handleScroll: Ee,
      handleContentResize: Me,
      handleContainerResize: He,
      handleYScrollMouseDown: Ie,
      handleXScrollMouseDown: De,
      cssVars: s ? void 0 : ce,
      themeClass: P == null ? void 0 : P.themeClass,
      onRender: P == null ? void 0 : P.onRender
    });
  },
  render() {
    var i;
    const {
      $slots: R,
      mergedClsPrefix: s,
      triggerDisplayManually: $,
      rtlEnabled: o,
      internalHoistYRail: W,
      yPlacement: Y,
      xPlacement: E,
      xScrollable: M
    } = this;
    if (!this.scrollable)
      return (i = R.default) === null || i === void 0 ? void 0 : i.call(R);
    const S = this.trigger === "none", w = (d, p) => v("div", {
      ref: "yRailRef",
      class: [`${s}-scrollbar-rail`, `${s}-scrollbar-rail--vertical`, `${s}-scrollbar-rail--vertical--${Y}`, d],
      "data-scrollbar-rail": !0,
      style: [p || "", this.verticalRailStyle],
      "aria-hidden": !0
    }, v(S ? he : ve, S ? null : {
      name: "fade-in-transition"
    }, {
      default: () => this.needYBar && this.isShowYBar && !this.isIos ? v("div", {
        class: `${s}-scrollbar-rail__scrollbar`,
        style: {
          height: this.yBarSizePx,
          top: this.yBarTopPx
        },
        onMousedown: this.handleYScrollMouseDown
      }) : null
    })), B = () => {
      var d, p;
      return (d = this.onRender) === null || d === void 0 || d.call(this), v("div", bt(this.$attrs, {
        role: "none",
        ref: "wrapperRef",
        class: [`${s}-scrollbar`, this.themeClass, o && `${s}-scrollbar--rtl`],
        style: this.cssVars,
        onMouseenter: $ ? void 0 : this.handleMouseEnterWrapper,
        onMouseleave: $ ? void 0 : this.handleMouseLeaveWrapper
      }), [this.container ? (p = R.default) === null || p === void 0 ? void 0 : p.call(R) : v("div", {
        role: "none",
        ref: "containerRef",
        class: [`${s}-scrollbar-container`, this.containerClass],
        style: this.containerStyle,
        onScroll: this.handleScroll,
        onWheel: this.onWheel
      }, v(de, {
        onResize: this.handleContentResize
      }, {
        default: () => v("div", {
          ref: "contentRef",
          role: "none",
          style: [{
            width: this.xScrollable ? "fit-content" : null
          }, this.contentStyle],
          class: [`${s}-scrollbar-content`, this.contentClass]
        }, R)
      })), W ? null : w(void 0, void 0), M && v("div", {
        ref: "xRailRef",
        class: [`${s}-scrollbar-rail`, `${s}-scrollbar-rail--horizontal`, `${s}-scrollbar-rail--horizontal--${E}`],
        style: this.horizontalRailStyle,
        "data-scrollbar-rail": !0,
        "aria-hidden": !0
      }, v(S ? he : ve, S ? null : {
        name: "fade-in-transition"
      }, {
        default: () => this.needXBar && this.isShowXBar && !this.isIos ? v("div", {
          class: `${s}-scrollbar-rail__scrollbar`,
          style: {
            width: this.xBarSizePx,
            right: o ? this.xBarLeftPx : void 0,
            left: o ? void 0 : this.xBarLeftPx
          },
          onMousedown: this.handleXScrollMouseDown
        }) : null
      }))]);
    }, y = this.container ? B() : v(de, {
      onResize: this.handleContainerResize
    }, {
      default: B
    });
    return W ? v(mt, null, y, w(this.themeClass, this.cssVars)) : y;
  }
}), Vt = be, Dt = be;
export {
  Dt as XScrollbar,
  Vt as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/scrollbar/src/Scrollbar.js
// module id = 104
// module chunks = 67